import {useTranslation} from 'react-i18next'

import {startOAuthSignIn} from './api'

export function OAuthLoginPage() {
  const {t} = useTranslation()

  const error = new URLSearchParams(globalThis.location.search).get('error')

  const handleLogin = () => {
    void (async () => {
      const url = await startOAuthSignIn(globalThis.location.href)

      if (url) {
        globalThis.location.href = url
      }
    })()
  }

  return (
    <div className='flex h-screen w-full items-center justify-center bg-background px-4'>
      <div className='flex w-full max-w-sm flex-col items-center gap-6 text-center'>
        <div className='flex flex-col items-center gap-2'>
          <h1 className='text-xl font-semibold tracking-tight'>{t('oauthLogin.title')}</h1>
          <p className='text-sm text-muted-foreground'>
            {t('oauthLogin.subtitle')}
          </p>
        </div>
        {error && (
          <div className='w-full rounded-md border border-destructive/50 bg-destructive/10 px-4 py-3 text-sm text-destructive'>
            {t(`oauthLogin.errors.${error}`, t('oauthLogin.errors.default'))}
          </div>
        )}
        <button
          type='button'
          className='inline-flex w-full cursor-pointer items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground shadow hover:bg-primary/90'
          onClick={handleLogin}
        >
          {t('oauthLogin.submit')}
        </button>
      </div>
    </div>
  )
}
